/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Serializer for answer object related to pitch question object. Serializes fields from Answer model and additionally adds name field with answering user full name
 */
export interface AnswerRequest {
  text: string;
  question: string;
}
